import { useState } from "react";
import { api, formatApiError } from "@/lib/api";

const EMPTY = { name: "", phone: "", email: "", project_type: "", budget: "", message: "", website: "" };

export const useEnquiryForm = (source) => {
    const [form, setForm] = useState(EMPTY);
    const [status, setStatus] = useState("idle");
    const [error, setError] = useState("");

    const set = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

    const submit = async (e) => {
        e.preventDefault();
        setStatus("loading");
        setError("");
        try {
            await api.post("/leads", { ...form, email: form.email || null, source });
            setStatus("done");
        } catch (err) {
            setStatus("idle");
            setError(formatApiError(err));
        }
    };

    return { form, set, status, error, submit };
};
